import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { PlatformLoader } from "../PlatformLoader";
import "./index.scss";

const ROUTE_LOADER_DURATION = 180;

function RouteTransition({ children }) {
  const location = useLocation();
  const previousPathRef = useRef(location.pathname);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    if (!("scrollRestoration" in window.history)) return undefined;

    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";

    return () => {
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);

    const scrollingElement = document.scrollingElement;
    if (scrollingElement) {
      scrollingElement.scrollTop = 0;
      scrollingElement.scrollLeft = 0;
    }
  }, [location.pathname]);

  useEffect(() => {
    if (previousPathRef.current === location.pathname) return undefined;

    previousPathRef.current = location.pathname;

    const prefersReducedMotion =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (prefersReducedMotion) return undefined;

    setIsTransitioning(true);
    const timer = window.setTimeout(
      () => setIsTransitioning(false),
      ROUTE_LOADER_DURATION
    );

    return () => window.clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      <PlatformLoader
        visible={isTransitioning}
        label="Preparando la vista"
      />
      <div
        key={location.pathname}
        className="route-view"
        aria-busy={isTransitioning}
      >
        {children}
      </div>
    </>
  );
}

export { RouteTransition };
